<template lang="pug">
div(
    :class="styles.root"
)
    TheText(
        :class="styles.description"
        name="titleM"
        align="center"
    ) Для оплаты отсканируйте QR-код с помощью приложения банка или камерой телефона
    QrCard(
        :class="styles.qr"
    )
    Timer(
        v-if="isDynamic && timestamp"
        :class="styles.timer"
    )
    div(
        :class="styles.buttons"
    )
        ButtonCopyQrImage(
            :class="styles.button"
        )
        ButtonShareLink(
            v-if="canShare"
            :class="styles.button"
        )
</template>

<script lang="ts">
import Vue, { computed, useCssModule } from 'vue'

import { QrCard } from '@/widgets/QrCard'
import { Timer } from '@/widgets/Timer'

import { TheText } from '@/shared/ui/TheText'
import { useAppStore } from '@/shared/model'

import ButtonCopyQrImage from '@/feature/ButtonCopyQrImage.vue'
import ButtonShareLink from '@/feature/ButtonShareLink.vue'

export default Vue.extend({
    name: 'QRState',
    props: {
        canShare: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const styles = useCssModule()

        const {
            state: { urlType, timestamp },
        } = useAppStore()

        const isDynamic = computed(() => urlType === 'dynamic')
        return {
            styles,
            isDynamic,
            timestamp,
        }
    },
    components: {
        ButtonCopyQrImage,
        ButtonShareLink,
        Timer,
        TheText,
        QrCard,
    },
})
</script>

<style module lang="scss" src="./QRState.module.scss" />
